import * as PIXI from 'pixi.js';
import { createMenuItem, createFolderItem, createSongItem, style } from '@/ui/menu-builder';
import { MenuScene } from "@/scenes/menu-scene";
import { readChartsFolderDemo } from '@/model/file';
import { HEIGHT, WIDTH } from '@/constants';
import { store } from '@/model/store';
const BUTTON_HEIGHT = 80, PADDING = BUTTON_HEIGHT * 0.2;

export class SelectSongScene extends MenuScene {

    constructor() {
        super("select-song"); // this is the scene name
        this.initHeaders();
    }

    initPanel() {
        // no panel for now
    }

    initHeaders() {
        const header = new PIXI.Text('Pick a song', {
            ...style,
            fontSize: 50,
            align: 'left',
        });
        header.anchor.set(0.5, 0.5);
        header.position.set(160, 40);
        this.addChild(header);
        const sub = new PIXI.Text('I suggest "twinkle-twinkle-little-star" as your first choice', {
            ...style,
            align: 'left',
            fontSize: 24
        });
        // sub.anchor.set(0.5, 0.5);
        sub.position.set(20, 80);
        this.addChild(sub);
        this.sub = sub;
    }

    async initButtons() {
    }

    renderFiles() {
        this.buttons.forEach(child => {
            if (child.__meta) 
                this.removeChild(child)
        });

        let offsetY = 100, offsetX = 480;
        const files = this.files;
        let buttons = files.map((file, index) => {
            if (file.isFolder) {
                offsetY += (BUTTON_HEIGHT + PADDING)
                const item1 = createFolderItem({
                    id: file.id,
                    yCoord: offsetY,
                    payload: (file.id === '⮑ BACK' ? readChartsFolderDemo() : file.files)
                });
                item1.y = offsetY;
                item1.x = WIDTH / 2;
                this.addChild(item1);
                return item1;
            } else {
                offsetY += (BUTTON_HEIGHT + PADDING);
                let mxlUrl = `public/xml/${file.id}`
                if (file.path) {
                    mxlUrl = `http://localhost:9990/${file.path}`
                }
                const item1 = createSongItem({
                    played: file.played,
                    progress: file.progress,
                    title: file.id,
                    payload: {
                        ...file,
                        mxlUrl
                    }
                });
                item1.y = offsetY;
                item1.x = WIDTH / 2;
                this.addChild(item1);
                return item1;
            }

        });

        const back = createMenuItem({
            text: 'Back',
            yCoord: HEIGHT - 70,
            clickActionName: 'NAVIGATE',
            clickActionPayload: {
                sceneName: 'menu-demo'
            }
        });

        this.addChild(back);
        back.position.set(WIDTH - 120, 60);
        this.buttons = [...buttons, back];
        this.files = null;
        // this.sub.text = this.files.length
    }

    setPayload(files) {
        if (files) {
            this.files = files;
        }
    }

    onReveal() {
        if (!this.files) {
            this.files = readChartsFolderDemo()
        }
        this.renderFiles();
    }
}